class WoodMaterialSelectorComponent extends HTMLElement {

  constructor() {
    super()
  }

  connectedCallback() {

    this.innerHTML = String.raw`
      <div class="panel">
        <div class="panel-body">
        <div id="wood-material-heading" class="bg-info  modal-body-shadow"></div>
          <div class="accordion material-selector-body" id="wood-material-accordion"></div>  
        </div>
      </div>
    `
    initWoodAccordion()
  } 
}

customElements.define('wood-material-selector-component', WoodMaterialSelectorComponent)

function onWoodMaterialSelected(woodMaterial) {
  var str = "<table class='table wood-material-box wood-material-table'><thead>";
  str += "<tr class='no-border'>";
  str += '<th>' + woodMaterial['Species'] + '</th><th>Fb</th><th>Ft</th><th>Fv</th><th>Fc</th><th>E</th>';
  str += '</thead></tr>';
  str += "<tr class='no-border'>";
  str += '<td>' + woodMaterial['Grade'] + '</td>';
  str += '<td>' + woodMaterial['Fb'] + '</td>';
  str += '<td>' + woodMaterial['Ft'] + '</td>';
  str += '<td>' + woodMaterial['Fv'] + '</td>';
  str += '<td>' + woodMaterial['Fc'] + '</td>';
  str += '<td>' + woodMaterial['E'] + '</td></tr>';
  str += '</table>';
  document.getElementById('wood-material-heading').innerHTML = str
}

function initWoodAccordion() {
  var materials = woodVisual2to4MaterialJson;
  var currentSpecies = '';
  var data = [];
  var grades = [];
  var str = ""


  for( var m in materials ) {
    let material = materials[m]
    if( currentSpecies !== material['Species'] ) {
      // species has changed
      if( currentSpecies !== '' ) {
        grades.sort(function(a, b) { return a.text > b.text })
        data.push({species: currentSpecies, grades: grades})
      }
      currentSpecies = material['Species']
      grades = []
    }
    grades.push(material['Grade'])
  }

  for(var i in data) {
    let material = data[i]
    str += `
    <div class="card">
      <div class="card-header" id="heading-${i}">
        <h5 class="mb-0">
          <button class="btn btn-primary btn-block" data-toggle="collapse" data-target="#wood-species-${i}">
            ${material.species}  
          </button>
        </h5>
      </div>
      <div id="wood-species-${i}" class="collapse" data-parent="#wood-material-accordion">
        <div id="wood-species-${i}-body" class="card-body"></div>
      </div>
    </div>
    `
  }

  document.getElementById('wood-material-accordion').innerHTML = str

  let count = 0
  for(var i in data) {
    let material = data[i]
    str = '<div class="material-list-group">'
    for(let j in material.grades) {
      str += `
      <a href="#" class="list-group-item list-group-item-action" onclick="onWoodGradeSelected(${count})">
        ${material.grades[j]}  
      </a>
      `
      count++
    }
    str += '</div>'
    document.getElementById(`wood-species-${i}-body`).innerHTML = str
  }

  onWoodGradeSelected(0)
}

function onWoodGradeSelected(index) {
  clearMaterialTableSelection()
  const customEvent = new CustomEvent('wood-material-selected', { detail: woodVisual2to4MaterialJson[index] })
  document.dispatchEvent(customEvent)
  onWoodMaterialSelected(woodVisual2to4MaterialJson[index])
}